import { UseCaseError } from '@digibricks/domains';

export class PaymentRequiredResultError<T> extends UseCaseError<T> {
  constructor(error?: string | Error) {
    super(error);
  }
}
